export { default, type ComplianceContainerProps } from './ComplianceContainer';
